<template>
  <div>
    <span v-for=" item in dateList" :key="item.key">
      <a-row>
        <a-col :span="22">
          <my-date
            :start-time="item.startTime"
            :end-time="item.endTime"
            @changeDate="(startValue,endValue) => changeDate(startValue,endValue,item.key)"
          ></my-date>
        </a-col>
        <a-col :span="2">
          <a @click="deleteDate(item.id,item.key)" style="margin-left: 5px; font-size: 12px">
            <a-icon type="close-circle" style="margin-left: 7px;color: red;font-size: 14px" theme="filled"/>
          </a>
        </a-col>
      </a-row>
    </span>
    <a-button style="width: 100%; margin-top: 16px; margin-bottom: 8px" type="dashed" icon="plus" @click="addDate">添加时间</a-button>
  </div>

</template>

<script>
import myDate from './myDate'
import ARow from 'ant-design-vue/es/grid/Row'
import ACol from 'ant-design-vue/es/grid/Col'
import moment from 'moment'

export default {
  components: {
    ACol,
    ARow,
    myDate
  },
  name: 'MachineDate',
  props: {
    childDateList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      dateList: [],
      count: 10000, // 此处不能使0，否则会重复
      deleteMaterialTimeDetailList: []
    }
  },
  methods: {
    // 点加号时触发
    addDate () {
      this.dateList.push({
        key: this.count
      })
      this.count = this.count + 1
    },
    // 删除时触发
    deleteDate (id, key) {
      if (id !== null && id !== '' && id !== undefined) {
        this.deleteMaterialTimeDetailList.push(id)
      }
      this.dateList = this.dateList.filter(item => item.key !== key)
      this.$emit('getChileDeleteList', this.deleteMaterialTimeDetailList)
      this.$emit('childChangeDate', this.dateList)
    },
    changeDate (startValue, endValue, key) {
      this.dateList.map(item => {
        if (item.key === key) {
          item.startTime = moment(startValue).format('YYYY-MM-DD HH:mm')
          item.endTime = moment(endValue).format('YYYY-MM-DD HH:mm')
          item.leadTime = (moment(item.endTime) - moment(item.startTime)) / 1000 / 60 // 转换为分钟存储
        }
      })
      this.$emit('childChangeDate', this.dateList)
    }
  },
  watch: {
    // 监听父组件传过来得数组
    childDateList: {
      deep: true,
      immediate: true,
      handler: function (newV) {
        this.dateList = newV
      }
    }
  }
}
</script>

<style scoped>

</style>
